const INTERNAL_WS_EVENTS = new Set(["connected", "CHAT_PRESENCE", "CHAT_MESSAGE", "CHAT_PING", "CHAT_READ"]);
const recentEvents = new Map();

const EVENT_LABELS = {
  BOOKING_CREATED: "Booking created",
  PUBLIC_BOOKING_CREATED: "Booking created",
  MECHANIC_ASSIGNED: "Mechanic assigned",
  READY_FOR_QA: "Ready for QA",
  QA_PASSED: "QA passed",
  QA_REJECTED: "QA rejected",
  SERVICE_PAYMENT_LINK_SENT: "Payment link ready",
  PAYMENT_COLLECTED: "Payment collected",
  RAZORPAY_PAYMENT_VERIFIED: "Payment received",
  FOLLOW_UP_BOOKING_CREATED: "Follow-up booking created",
  SHOP_SALE: "Shop sale completed",
  SHOP_PAYMENT_RECEIVED: "Shop payment received",
  PRODUCT_BOOKING_REQUESTED: "Product booking requested",
  PRODUCT_BOOKING_CONFIRMED: "Product pickup locked",
  PRODUCT_BOOKING_RELEASED: "Product pickup released",
};

export const isInternalWsEvent = (event) => INTERNAL_WS_EVENTS.has(event?.type);

export const showWsEventToast = (event, toast) => {
  if (!event?.type || isInternalWsEvent(event)) return false;

  const id = event.data?.id || event.data?.booking_id || event.data?.plate_number || "";
  const key = `${event.type}:${id}`;
  const now = Date.now();
  if ((recentEvents.get(key) || 0) + 2500 > now) return false;
  recentEvents.set(key, now);

  const notification = event.type === "NOTIFICATION_CREATED" ? event.data : null;
  const label = notification
    ? (EVENT_LABELS[notification.event_type] || notification.event_type?.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) || "Notification")
    : (EVENT_LABELS[event.type] || event.type.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()));
  toast(label, {
    id: `ws-${key}`,
    description: notification?.body || event.data?.plate_number || "",
    duration: 2500,
  });
  return true;
};
